<style>
.completed {
  @apply text-gray-800  bg-gray-100;
}
.completed:hover {
  @apply text-gray-800  bg-gray-200;
}
.noShow {
  @apply text-red-800 bg-red-100;
}

.noShow:hover {
  @apply text-red-800 bg-red-200;
}

.slot {
  @apply rounded-md border transition-all duration-200 shadow-sm;
}
.slot:hover {
  @apply shadow-md transform scale-110 z-40;
}
</style>

<script>
import { link } from "svelte-routing"
import { format } from "date-fns"
import { toZonedTime } from "date-fns-tz"

import Icon from "@local/components/images/Icon.svelte"

import { calculateScheduleStyles } from "./utils"
import TemplateString from "../../../../../shared/components/TemplateString.svelte"

export let columns = undefined
export let column = undefined
export let workflowId = undefined
export let workflow = undefined
export let status = undefined
export let startsAt = undefined
export let endsAt = undefined
export let timeZone = undefined

$: completed = status === "Completed"
$: noShow = status === "No Show"

let icon = ""
if (workflow?.consultType === "Phone") {
  icon = "phone"
} else if (workflow?.consultType === "Video") {
  icon = "videocam"
} else if (workflow?.consultType === "In Person") {
  icon = "apartment"
}

export function parseOnTz(date, timeZone) {
  return toZonedTime(date, timeZone)
}
</script>

<div
  class="absolute slot text-xs font-semibold leading-none truncate border-b border-transparent z-10"
  style="{calculateScheduleStyles({ startsAt, endsAt, column }, columns)}"
>
  <div
    class="w-full h-full px-1 truncate group"
    class:completed="{completed}"
    class:noShow="{noShow}"
  >
    <div class="flex w-full justify-between items-center self-center">
      <a
        class="flex flex-col font-semibold cursor-pointer"
        href="{`/workflows/${workflowId}`}"
        target="_blank"
        use:link
      >
        <div>
          <div>
            <span class="text-sm opacity-100"
              >{format(parseOnTz(startsAt, timeZone), "hh:mmaaa")}</span
            >
            <span class="text-xs opacity-75">{workflow.subdomain}</span>
          </div>
          <div class="text-sm opacity-100 leading-none">
            {workflow?.firstName}
            {workflow?.lastName[0]}

            <span class="opacity-75"
              >, <TemplateString content="{workflow.age}" /></span
            >
          </div>
        </div>
      </a>
      <div class="flex gap-1">
        {#if !!workflow.veteran}
          <Icon size="sm">military_tech</Icon>
        {/if}
        <Icon size="sm">
          {icon}
        </Icon>
      </div>
    </div>
  </div>
</div>
